import { useDocumentTitle } from 'usehooks-ts';
import { useAuth } from 'drycut-auth';
import { useNavigate } from 'react-router';
import { Queues } from 'stylist/components';

export function Queue(): React.ReactNode {
  useDocumentTitle('DRYCUT - Queue');

  const navigate = useNavigate();
  const { currentSlug } = useAuth();

  if (!currentSlug) {
    navigate('/not-found');
    return null;
  }

  return <Queues slug={currentSlug} />;
}
